import { endpoint } from '@shared/services/endpoint'
import useSWR, { preload } from 'swr'

import type { Response } from '../types/common'
import type { SiteConfiguration } from '../types/site-configuration'

import { getRequest } from '../../../shared/services/fetcher'

export type SiteConfigurationResponse = Response<SiteConfiguration>

preload(endpoint.frontend.SITE_CONFIGURATION, getRequest)

export function useSiteConfiguration() {
  const { data, error, isLoading } = useSWR<SiteConfiguration, Error>(
    endpoint.frontend.SITE_CONFIGURATION,
    getRequest,
  )
  return {
    error,
    isLoading,
    menus: data?.menus,
    popups: data?.popups,
    settings: data?.settings,
    siteInfo: data?.siteInfo,
  }
}

export default useSiteConfiguration
